import { MoreOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { Eye, FileLock, Handshake, Logs, Shield, ShieldOff, Trash } from "lucide-react";

const DataTableActionsRender = ({ tableActions, val }) => {
    const value = val?.row;
    const items = tableActions?.map((actionItem, actionIndex) => {
        const handleClick = actionItem?.handleOnClick

        if (actionItem?.isView) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className='!text-sm text-blue-600'>View</span>,
            icon: <Eye className='icon text-blue-600' />
        }

        if (actionItem?.isLogs) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className='!text-sm'>{actionItem?.label}</span>,
            icon: <Logs className='icon' />
        }

        if (actionItem?.isPasswordPolicies) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className='!text-sm'>Password Policies</span>,
            icon: <FileLock className='icon' />
        }

        if (actionItem?.isDeactivate) {
            const isActive = value?.status?.toLowerCase() === "active";
            const activeClass = isActive ? "text-red-600" : "text-green-600";
            return {
                danger: !isActive,
                key: actionIndex + 1,
                onClick: () => handleClick(value),
                label: <span className={`!text-sm ${activeClass}`}>{isActive ? "Deactivate" : "Activate"}</span>,
                icon: isActive ? <ShieldOff className={`icon ${activeClass}`} /> : <Shield className={`icon ${activeClass}`} />
            }
        }

        if (actionItem?.isAssign) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className='!text-sm'>{actionItem?.label}</span>,
            icon: <Handshake className='icon' />
        }

        if (actionItem?.isMFA) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className={`!text-sm  ${value?.adMfaFlag === 0 ? "text-blue-600" : ""}`}>{value?.adMfaFlag === 0 ? "Enable MFA" : "Disable MFA"}</span>,
            danger: !(value?.adMfaFlag === 0),
            icon: value?.adMfaFlag === 0 ? <Shield className='icon text-blue-600' /> : <ShieldOff className='icon' />
        }

        if (actionItem?.isDelete) return {
            key: actionIndex + 1,
            onClick: () => handleClick(value),
            label: <span className='!text-sm'>Delete</span>,
            danger: true,
            icon: <Trash className='icon' />
        }
    })
    return (<>
        <Dropdown placement='bottomRight' overlayClassName='table-action-menu' className='!p-2 !py-1 cursor-pointer !w-fit' menu={{ items }}>
            <div>
                <MoreOutlined />
            </div>
        </Dropdown>
    </>)
}

export default DataTableActionsRender